var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 47,
    viewBox: "0 0 233 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3696 0.121414L93.3696 46.8668L140.115 46.8668L140.115 0.121418L93.3696 0.121414Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08661e-06 -0.000137329L0 46.7452L46.7454 46.7452L46.7454 -0.000133242L4.08661e-06 -0.000137329Z",
    fill: "#A69D69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.054 0.0154877L140.054 46.7609L186.8 46.7609L186.8 0.0154918L140.054 0.0154877Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6846 0.0606232L46.6846 46.806L93.4299 46.806L93.43 0.0606273L46.6846 0.0606232Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.739 0.0763359L186.739 46.8217L233.484 46.8217L233.484 0.07634L186.739 0.0763359Z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.032 0.181601L186.677 11.8264L186.677 0.181602L175.032 0.181601Z",
    fill: "#A69D69"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.387 0.181589L151.743 0.181588L186.677 35.1158L186.677 23.4711L163.387 0.181589Z",
    fill: "#A69D69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.098 0.181728L186.677 46.7607L175.032 46.7607L140.098 11.8265L140.098 0.181728Z",
    fill: "#A69D69"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.098 23.4712L163.387 46.7607L151.742 46.7607L140.098 35.116L140.098 23.4712Z",
    fill: "#A69D69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3177 11.8264C16.8864 11.8264 11.6729 17.0399 11.6729 23.4711C11.6729 29.9023 16.8864 35.1159 23.3176 35.1159C29.7489 35.1159 34.9624 29.9023 34.9624 23.4711C34.9624 17.0399 29.7489 11.8264 23.3177 11.8264Z",
    fill: "#2E2E2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0628 11.8264C63.6315 11.8264 58.418 17.0399 58.418 23.4711C58.418 29.9023 63.6315 35.1159 70.0628 35.1159C76.494 35.1159 81.7075 29.9023 81.7075 23.4711C81.7075 17.0399 76.494 11.8264 70.0628 11.8264Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.688 0.118545L93.3979 23.409L116.688 46.6995L139.979 23.409L116.688 0.118545Z",
    fill: "#2E2E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.421 46.76L210.132 23.4705L233.421 0.180969L233.421 46.76Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/Bg2.93bc196dc3642d154c67a390a688a7ff.svg";
export { ForwardRef as ReactComponent };